import {
  PassportActionType,
  PassportProtocolType,
  PassportRuleType,
  PassportSourceDestinationHostType,
  PassportSourceDestinationUserType,
  PassportPeriodType,
} from "./enums";
import { IPassport } from "./types";

export const fakePassports: IPassport[] = [
  {
    id: "909a60ee-954a-4b6f-953d-aeb49962769c",
    created_time: 1747194105,
    updated_time: null,
    type: PassportRuleType.HOST_HOST,
    action: PassportActionType.ACCEPT,
    enabled: true,
    priority: 1747194105,
    ports: [
      {
        port: "22",
        protocol: PassportProtocolType.SSH,
      },
      {
        port: "12345",
        protocol: PassportProtocolType.CUSTOM,
      },
    ],
    sources: [
      {
        id: 25607,
        name: "DESKTOP-CYSTACK",
        type: PassportSourceDestinationHostType.HOST,
      },
      {
        id: 25608,
        name: "A tag",
        type: PassportSourceDestinationHostType.TAG,
      },
      {
        id: 25609,
        name: "Aother tag",
        type: PassportSourceDestinationHostType.TAG,
      },
    ],
    destinations: [
      {
        id: 25607,
        name: "DESKTOP-CYSTACK",
        type: PassportSourceDestinationHostType.HOST,
      },
    ],
    // Time frame
    limit_time: true,
    duration_type: PassportPeriodType.DAILY,
    limit_start_time: 1747194105,
    limit_end_time: 1747280605,
    days: [1, 2, 3, 4, 5], // Tuesday to Saturday
    repeat_number: 3,
    limit_start_date: 1747194000,
  },
  {
    id: "b12c78ee-a54d-4c8e-954a-abd9432f678d",
    created_time: 1747194000,
    updated_time: 1747194050,
    type: PassportRuleType.HOST_HOST,
    action: PassportActionType.REJECT,
    enabled: false,
    priority: 1747194000,
    ports: [
      {
        port: "443",
        protocol: PassportProtocolType.HTTPS,
      },
      {
        port: "80",
        protocol: PassportProtocolType.HTTP,
      },
    ],
    sources: [
      {
        id: 25608,
        name: "LAPTOP-ADMIN",
        type: PassportSourceDestinationHostType.HOST,
      },
    ],
    destinations: [
      {
        id: 10001,
        name: "Internal Network",
        type: PassportSourceDestinationHostType.TAG,
      },
    ],
    // Time frame
    limit_time: true,
    duration_type: PassportPeriodType.WEEKLY,
    limit_start_time: 1747194000,
    limit_end_time: 1747799200,
    days: [0, 6], // Monday and Friday
    repeat_number: 2,
    limit_start_date: 1747194000,
  },
  {
    id: "d24e90ff-c65b-4e9c-b76d-5ef87523a9bc",
    created_time: 1747193000,
    updated_time: null,
    type: PassportRuleType.USER_HOST,
    action: PassportActionType.ACCEPT,
    enabled: true,
    priority: 1747193000,
    ports: [
      {
        port: "3389",
        protocol: PassportProtocolType.RDP,
      },
    ],
    sources: [
      {
        id: 10002,
        name: "Marketing",
        type: PassportSourceDestinationUserType.DEPARTMENT,
      },
      {
        id: 10002,
        name: "khaitq",
        type: PassportSourceDestinationUserType.USER,
      },
    ],
    destinations: [
      {
        id: 25609,
        name: "SERVER-DATABASE",
        type: PassportSourceDestinationHostType.HOST,
      },
    ],
    // Time frame
    limit_time: true,
    duration_type: PassportPeriodType.MONTHLY,
    limit_start_time: 1747193000,
    limit_end_time: 1749872400,
    days: [0, 2, 4], // Monday, Wednesday, Friday
    repeat_number: 1,
    limit_start_date: 1747194000,
  },
];
